import React from 'react'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import { App } from 'antd'
import i18 from 'i18next'

interface DiscardChangesModalProps {
  onConfirm: () => void
}

/**
 * Hook that returns a function to show a discard changes confirmation modal
 * Uses App.useApp() to ensure ConfigProvider styles are applied
 *
 * Usage:
 * ```typescript
 * const discardChangesModal = useDiscardChangesModal()
 * discardChangesModal({
 *   onConfirm: () => {
 *     resetAllChanges()
 *   }
 * })
 * ```
 */
export const useDiscardChangesModal = () => {
  const { modal } = App.useApp()

  return ({ onConfirm }: DiscardChangesModalProps) => {
    modal.confirm({
      title: i18.t('modal:discardChangesTitle', 'Muokkaustilan sulkeminen.'),
      content: i18.t('modal:discardChangesContent', 'Haluatko sulkea muokkaustilan tallentamatta?'),
      icon: <ExclamationCircleOutlined />,
      okText: i18.t('global:ok', 'Kyllä'),
      cancelText: i18.t('global:no', 'Ei'),
      onOk: onConfirm,
      okButtonProps: {
        style: {
          width: 100
        }
      },
      cancelButtonProps: {
        style: {
          width: 100
        }
      }
    })
  }
}
